/* global IntersectionObserver */
export const observeDarkBlocks = () => {
    const darkBlocksIOCallback = (entries, observer) => {
        const $navContainer = document.body.querySelector('.navigation-container')
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // console.log('is over', entry.target.dataset.shade === 'dark' ? 'dark' : 'light') // debug only
                $navContainer.dataset.topmost = entry.target.dataset.shade === 'dark' ? true : false
            } 
        })
    }

    const darkBlocksIntersectionObserver = new IntersectionObserver(darkBlocksIOCallback, {
        root: null,
        rootMargin: '0px 0px -90%',
        threshold: 0,
    })

    ;[ ...document.querySelectorAll('.ygg-block[data-shade]') ].forEach($block => darkBlocksIntersectionObserver.observe($block))
}